<ion-header>
  <div class="flex-space-between" style="padding: 8px">
    <div class="button-container flexed-align-center">
      <div class="flexed-align-center">
        <ion-searchbar
          mode="ios"
          placeholder="Search channels..."
          showCancelButton="never"
          class="rounded-search-bar"
          [(ngModel)]="searchText"
          (ionChange)="handleFilters()"
        ></ion-searchbar>
        <app-filter-button
          [options]="filterOptions"
          (didChange)="filtersDidChange($event)"
          [projectId]="authService.selectedProject?.id ?? undefined"
        ></app-filter-button>
        <ion-button
          color="dark"
          fill="clear"
          class="hidden-sm btn-small"
          (click)="
            showArchived = !showArchived; searchText = ''; loadChannels()
          "
          *ngIf="channelType === 'slack'"
        >
          <ion-icon
            [name]="showArchived ? 'checkmark-circle' : 'ellipse-outline'"
            class="padded-icon checkbox-icon"
          >
          </ion-icon>
          Show archived
        </ion-button>
      </div>
    </div>
    <div style="display: flex">
      <ion-button
        *ngIf="
          channelType === 'email' &&
          validEmailDomains?.length &&
          authService.isTenantAdmin
        "
        routerLink="/dashboard/settings/security"
        routerDirection="root"
        fill="clear"
        color="success"
        class="hidden-sm"
      >
        <ion-icon name="checkmark-circle"></ion-icon>
        <span class="text-with-left-icon hidden-sm">
          {{ validEmailDomains?.length }} valid email domain{{
            validEmailDomains?.length > 1 ? "s" : ""
          }}
        </span>
      </ion-button>
      <ion-button
        *ngIf="
          channelType === 'email' &&
          validEmailDomains &&
          !validEmailDomains?.length &&
          authService.isTenantAdmin
        "
        routerLink="/dashboard/settings/security"
        routerDirection="root"
        fill="clear"
        color="dark"
        class="hidden-sm button-dark-border"
      >
        <ion-icon name="information-circle"></ion-icon>
        <span class="text-with-left-icon hidden-sm">
          Tip: validate your email domain
        </span>
      </ion-button>
      <ion-button
        [hidden]="selectedChannels.length"
        [routerLink]="'/dashboard/channels/new'"
        *ngIf="showCreateButton && channelType === 'slack'"
      >
        <ion-icon name="logo-slack"></ion-icon>
        <span class="icon-plus-accessory">+</span>
        <span class="text-with-left-icon hidden-sm">
          Connect Slack channels
        </span>
      </ion-button>
      <ion-button
        [hidden]="selectedChannels.length"
        (click)="newMicrosoftTeams()"
        *ngIf="showCreateButton && channelType === 'microsoft-teams'"
      >
        <ion-icon name="custom-teams"></ion-icon>
        <span class="icon-plus-accessory">+</span>
        <span class="text-with-left-icon hidden-sm">
          New Microsoft Teams connection
        </span>
      </ion-button>
      <ion-button
        [hidden]="selectedChannels.length"
        *ngIf="showCreateButton && channelType === 'email'"
        (click)="newEmailInbox()"
      >
        <ion-icon name="mail"></ion-icon>
        <span class="icon-plus-accessory">+</span>
        <span class="text-with-left-icon hidden-sm"> New email inbox </span>
      </ion-button>
      <ion-button
        [hidden]="selectedChannels.length"
        (click)="newInAppChat()"
        *ngIf="showCreateButton && channelType === 'widget'"
      >
        <ion-icon name="chatbubble"></ion-icon>
        <span class="icon-plus-accessory">+</span>
        <span class="text-with-left-icon hidden-sm">
          New in-app chat connection
        </span>
      </ion-button>
      <ion-button
        [hidden]="selectedChannels.length"
        [routerLink]="'/dashboard/channels/jsm/new'"
        *ngIf="showCreateButton && channelType === 'jsm'"
      >
        <ion-icon name="custom-jsm-white"></ion-icon>
        <span class="icon-plus-accessory">+</span>
        <span class="text-with-left-icon hidden-sm"> New JSM connection </span>
      </ion-button>
      <ion-button
        fill="clear"
        color="dark"
        (click)="exportAsCsv()"
        ngxTippy
        [tippyProps]="{
          arrow: false,
          placement: 'bottom'
        }"
        data-tippy-content="Download as CSV"
        class="hidden-sm"
      >
        <ion-icon name="cloud-download"></ion-icon>
      </ion-button>
    </div>
  </div>
  <div [hidden]="!selectedChannels.length" style="padding: 8px">
    <ion-button fill="clear" color="dark" [disabled]="true" class="btn-small">
      {{
        selectAllPagesForBulkUpdate
          ? channelListDataSource.lastResponse.totalCount
          : selectedChannels.length
      }}
      selected:
    </ion-button>
    <ion-button
      (click)="composeEmail()"
      [disabled]="isLoading"
      style="margin: 0 4px"
      class="btn-small"
    >
      <ion-icon name="mail"></ion-icon>
      <span class="text-with-left-icon hidden-sm"> Compose email </span>
    </ion-button>
    <ion-button
      (click)="composeSlack()"
      [disabled]="isLoading"
      style="margin: 0 4px"
      class="btn-small"
    >
      <ion-icon name="logo-slack"></ion-icon>
      <span class="text-with-left-icon hidden-sm">
        Compose Slack broadcast
      </span>
    </ion-button>
    <ion-button
      (click)="manageTags()"
      [disabled]="isLoading"
      color="light"
      style="margin: 0 4px"
      class="btn-small"
    >
      <ion-icon name="pricetags"></ion-icon>
      <span class="text-with-left-icon hidden-sm"> Manage tags </span>
    </ion-button>
    <!-- <ion-button fill="outline" (click)="showEditOptions()" [disabled]="isLoading" style="margin: 0 4px">
      <span class="text-with-right-icon hidden-sm"> Edit </span>
      <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
    </ion-button> -->
    <ng-container *ngIf="selectedChannels.length >= limit">
      <ng-container *ngIf="!selectAllPagesForBulkUpdate">
        <ion-button
          fill="clear"
          color="dark"
          (click)="selectAllPagesForBulkUpdate = true"
          class="btn-small"
        >
          Select all
          {{ channelListDataSource.lastResponse.totalCount }} channels?
        </ion-button>
      </ng-container>
    </ng-container>
    <ion-button
      fill="clear"
      color="dark"
      (click)="selectedChannels = []; selectAllPagesForBulkUpdate = false"
      [disabled]="isLoading"
      style="margin: 0 4px"
      class="btn-small"
    >
      Clear selection
    </ion-button>
  </div>
</ion-header>
<ion-content>
  <ng-container>
    <ngx-datatable
      class="material datatable-row-borders datatable-fixed-header datatable-fixed-footer"
      [columnMode]="ColumnMode.force"
      [limit]="limit"
      [headerHeight]="44"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="true"
      [selected]="selectedChannels"
      selectionType="checkbox"
      [selectAllRowsOnPage]="false"
      [displayCheck]="false"
      style="height: unset"
      paginated
      [dataSource]="channelListDataSource"
      [reorderable]="true"
      (select)="onSelect($event)"
      [loadingIndicator]="isLoading"
    >
      <ngx-datatable-column
        [width]="44"
        [minWidth]="44"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [headerCheckboxable]="true"
        [checkboxable]="true"
      >
      </ngx-datatable-column>
      <ngx-datatable-column name="Name" [minWidth]="250">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a
            [routerLink]="['/dashboard/channels', row.id, 'overview']"
            routerDirection="root"
            class="vertical-align-center row-title row-link"
          >
            <div style="width: 29px; height: 29px; margin-right: 10px">
              <img
                *ngIf="row.slackTeams?.length === 1 && row.slackTeams[0]?.icon"
                [src]="row.slackTeams[0].icon"
                style="object-fit: cover; border-radius: 8px"
              />
              <div
                *ngIf="
                  row.slackTeams?.length !== 1 ||
                  (row.slackTeams?.length === 1 && !row.slackTeams[0]?.icon)
                "
                class="table-icon"
                [ngClass]="{
                  'bg-secondary': row.type === CHANNEL_TYPES.SLACK,
                  'bg-primary':
                    row.type === CHANNEL_TYPES.WIDGET ||
                    row.type === CHANNEL_TYPES.MICROSOFT_TEAMS,
                  'bg-tertiary': row.type === CHANNEL_TYPES.EMAIL
                }"
              >
                <ion-icon
                  [name]="
                    row.type === CHANNEL_TYPES.SLACK
                      ? 'logo-slack'
                      : row.type === CHANNEL_TYPES.WIDGET
                        ? 'chatbubble'
                        : row.type === CHANNEL_TYPES.MICROSOFT_TEAMS
                          ? 'custom-teams'
                          : 'mail'
                  "
                ></ion-icon>
              </div>
            </div>
            <span class="row-title">
              {{ row.name ?? PRIVATE_CHANNEL_NAME }}
            </span>
          </a>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="Slack Channel"
        prop="slackChannel?.name"
        [minWidth]="225"
        [sortable]="false"
        *ngIf="channelType !== 'jsm'"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <!-- For email customers, show channel from InboundEmailRule if available, otherwise fallback to slackChannel -->
          <ion-badge color="light">
            <ng-container *ngIf="row.type === CHANNEL_TYPES.EMAIL">
              <ion-icon
                name="lock-closed"
                *ngIf="
                  row.inboundEmailRule?.slackChannel?.isPrivate &&
                  row.inboundEmailRule?.slackChannel?.name
                "
              ></ion-icon>
              <span
                *ngIf="
                  row.inboundEmailRule?.slackChannel?.name &&
                  !row.inboundEmailRule?.slackChannel?.isPrivate
                "
                class="channel-hashtag"
                >#</span
              >
              <span *ngIf="row.inboundEmailRule?.slackChannel">{{
                formatSlackChannelName(row.inboundEmailRule?.slackChannel)
              }}</span>
              <i *ngIf="!row.inboundEmailRule?.slackChannel">None</i>
            </ng-container>

            <ng-container *ngIf="row.type === CHANNEL_TYPES.WIDGET">
              <ion-icon
                name="lock-closed"
                *ngIf="
                  row.widget?.slackChannel?.isPrivate &&
                  row.widget?.slackChannel?.name
                "
              ></ion-icon>
              <span *ngIf="row.widget?.slackChannel">{{
                formatSlackChannelName(row.widget?.slackChannel)
              }}</span>
              <i *ngIf="!row.widget?.slackChannel">None</i>
            </ng-container>

            <ng-container *ngIf="row.type === CHANNEL_TYPES.MICROSOFT_TEAMS">
              <ion-icon
                name="lock-closed"
                *ngIf="
                  row.externalChatConnection?.slackChannel?.isPrivate &&
                  row.externalChatConnection?.slackChannel?.name
                "
              ></ion-icon>
              <span *ngIf="row.externalChatConnection?.slackChannel">{{
                formatSlackChannelName(row.externalChatConnection?.slackChannel)
              }}</span>
              <i *ngIf="!row.externalChatConnection?.slackChannel">None</i>
            </ng-container>

            <!-- For non-email customers, show regular slackChannel -->
            <ng-container *ngIf="row.type === CHANNEL_TYPES.SLACK">
              <ion-icon
                name="lock-closed"
                *ngIf="row.slackChannel?.isPrivate && row.slackChannel?.name"
              ></ion-icon>
              <span
                *ngIf="row.slackChannel?.name && !row.slackChannel?.isPrivate"
                class="channel-hashtag"
                >#</span
              >
              <span *ngIf="row.slackChannel">{{
                formatSlackChannelName(row.slackChannel)
              }}</span>
              <i *ngIf="!row.slackChannel">None</i>
            </ng-container>
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Members"
        prop="followerCount"
        [maxWidth]="86"
        [minWidth]="86"
        [sortable]="false"
        *ngIf="channelType === 'slack'"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="light">
            <ion-icon name="people"></ion-icon>
            {{ row.followerCount }}
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="Type"
        prop="isInternal"
        [maxWidth]="92"
        [minWidth]="92"
        [width]="92"
        [sortable]="false"
        *ngIf="channelType === 'slack'"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="light" *ngIf="row.isInternal"
            ><ion-icon name="people"></ion-icon> internal</ion-badge
          >
          <ion-badge color="light" *ngIf="!row.isInternal">
            <ion-icon name="business"></ion-icon> shared
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="JSM Instance"
        [minWidth]="200"
        [sortable]="false"
        *ngIf="channelType === 'jsm'"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="light">
            {{ row.jsmChannel?.jsmInstance?.name }}
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Service Desk"
        [minWidth]="150"
        [sortable]="false"
        *ngIf="channelType === 'jsm'"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="light">
            {{ row.jsmChannel?.jsmServiceDesk?.key }}
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Tags" [minWidth]="250" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge
            color="success"
            *ngFor="let tag of row.tags"
            (click)="editTagForChannel(row.id, tag.id)"
            class="clickable"
          >
            <span [title]="getTagsForRow(row)"> {{ tag.name }} </span>
          </ion-badge>
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            style="--padding-start: 4px; --padding-end: 4px; opacity: 0.8"
            (click)="addTagToChannel(row.id)"
          >
            <ion-label>
              <ion-icon name="pricetag"></ion-icon
              ><ion-icon name="add-outline"></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="SLA"
        prop="supportStepRuleset"
        [minWidth]="180"
        [sortable]="false"
        *ngIf="channelType === 'slack'"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            (click)="showSLAOptions(row)"
            style="margin-left: -13px"
          >
            <ion-label *ngIf="row.supportStepRuleset?.name">
              {{ row.supportStepRuleset?.name }}
            </ion-label>
            <ion-label
              *ngIf="!row.supportStepRuleset && !row.supportSteps?.length"
            >
              Default
            </ion-label>
            <ion-label *ngIf="row.supportSteps?.length"> Custom </ion-label>
            <ion-label>
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Project"
        prop="project?.name"
        [minWidth]="225"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-icon
            name="lock-closed"
            *ngIf="row.project?.visibility === PROJECT_VISIBILITY.RESTRICTED"
          ></ion-icon>
          {{ row.project?.name }}
          <i *ngIf="!row.project?.name">None</i>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Created"
        prop="createdAt"
        [minWidth]="170"
        [maxWidth]="170"
        [width]="170"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          {{ value | date: "MMM d yyyy" }}
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </ng-container>
  <div
    *ngIf="
      channelListDataSource.lastResponse?.data &&
      !channelListDataSource.lastResponse?.data?.length
    "
  >
    <ion-card
      style="margin: 60px; padding: 0 20px"
      class="settings-title-section"
    >
      <ng-container *ngIf="channelType === 'slack'">
        <h1>
          <ion-icon name="book-outline"></ion-icon>Connecting Slack Channels
        </h1>
        <p class="subtitle">
          Connect Slack channels to your Unthread dashboard, and start chatting
          with your customers right away.
        </p>
        <p class="subtitle" style="opacity: 1; margin: 15px 0 30px 0">
          <a
            href="https://docs.unthread.io/account-setup/connect-channels"
            target="_blank"
          >
            Learn more
            <ion-icon
              name="chevron-forward-outline"
              class="icon-padded-left"
            ></ion-icon>
          </a>
        </p>
      </ng-container>
      <ng-container *ngIf="channelType === 'email'">
        <h1>
          <ion-icon name="book-outline"></ion-icon>Set up a Shared Email Inbox
        </h1>
        <p class="subtitle">
          Forward emails into Slack and create a shared inbox where team members
          can collaborate and reply.
        </p>
        <p class="subtitle" style="opacity: 1; margin: 15px 0 30px 0">
          <a
            href="https://docs.unthread.io/email/email-slack-connector"
            target="_blank"
          >
            Learn more
            <ion-icon
              name="chevron-forward-outline"
              class="icon-padded-left"
            ></ion-icon>
          </a>
        </p>
      </ng-container>
      <ng-container *ngIf="channelType === 'widget'">
        <h1>
          <ion-icon name="book-outline"></ion-icon>Embed In-App Chat or a
          Customer Portal
        </h1>
        <p class="subtitle">
          Embed live chat into your website, share messages into Slack,
          collaborate with your team.
        </p>
        <p class="subtitle" style="opacity: 1; margin: 15px 0 30px 0">
          <a href="https://docs.unthread.io/in-app/chat-widget" target="_blank">
            Learn more
            <ion-icon
              name="chevron-forward-outline"
              class="icon-padded-left"
            ></ion-icon>
          </a>
        </p>
      </ng-container>
      <ng-container *ngIf="channelType === 'microsoft-teams'">
        <h1>
          <ion-icon name="book-outline"></ion-icon>Connect Microsoft Teams to
          Slack
        </h1>
        <p class="subtitle">
          Forward Microsoft Teams messages into a channel, discuss internally,
          and send replies right from Slack or your Unthread dashboard.
        </p>
        <p class="subtitle" style="opacity: 1; margin: 15px 0 30px 0">
          <a
            href="https://docs.unthread.io/integrations/microsoft-teams"
            target="_blank"
          >
            Learn more
            <ion-icon
              name="chevron-forward-outline"
              class="icon-padded-left"
            ></ion-icon>
          </a>
        </p>
      </ng-container>
      <!-- <ion-badge *ngIf="validEmailDomains?.length" color="light">
          <ion-icon name="send-outline"></ion-icon>
          Sending from {{ validEmailDomains[0].domain }}
        </ion-badge>
        <br />

        <ion-badge *ngIf="!validEmailDomains?.length" color="light">
          <ion-icon name="information-circle"></ion-icon>
          Recommendation:
          <a routerLink="/dashboard/settings/security" routerDirection="root">validate your email domain</a>
        </ion-badge> -->
    </ion-card>
  </div>
</ion-content>
